module.exports = __webpack_public_path__ + "static/media/_MG_9223_rsz.0129e1bc.jpg";